//
//
//
//
//
//

import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  name: "lyric",
  data () {
    return {
        msg:"歌词功能待实现……"
    };
  },
  components: {}
}




// WEBPACK FOOTER //
// ./src/components/Lyric.vue